import * as React from 'react';
import { IShowcase } from '../../types/showcase/props';
import { numericFormat, TextForms } from '../../utils/formatText/numericFormat';
import { ContentWrapper } from '../ContentWrapper';
import { Form } from '../Form';

import * as styles from './styles.css';

export interface IShowcaseCatProps extends IShowcase {
  banksNumber: number;
}

const fromForms: TextForms = ['ведущего банка', 'ведущих банков', 'ведущих банков'];
const getFromBankTextForm = (num: number) => numericFormat(num, fromForms);

export const ShowcaseCat: React.FC<IShowcaseCatProps> = ({
  formTitle,
  buttonTitle,
  error,
  loading,
  phone,
  submitPhone,
  setPhone,
  setOpen,
  banksNumber,
}) => {
  return (
    <div className={styles['wrapper']}>
      <ContentWrapper>
        <div className={styles['container']}>
          <div className={styles['content']}>
            <div className={styles['logo']} />
            <div className={styles['text']}>
              Бесплатный сервис, который&nbsp;поможет вам&nbsp;за&nbsp;10&nbsp;минут сравнить&nbsp;ипотечные
              предложения&nbsp;от&nbsp;{banksNumber || 'многих'} {getFromBankTextForm(banksNumber)} и&nbsp;выбрать
              лучшее онлайн
            </div>
          </div>
          <div className={styles['form']}>
            <Form
              formTitle={formTitle}
              buttonTitle={buttonTitle}
              error={error}
              loading={loading}
              phone={phone}
              submitPhone={submitPhone}
              setPhone={setPhone}
              setOpen={setOpen}
            />
          </div>
        </div>
      </ContentWrapper>
    </div>
  );
};
